function firebaseConfig() {
    return {
        apiKey: "AIzaSyD7JPbXj-Mb3XTSN58UOzB6iR0oYrEXOTE",
        authDomain: "qualy-3b163.firebaseapp.com",
        databaseURL: "https://qualy-3b163-default-rtdb.firebaseio.com",
        projectId: "qualy-3b163",
        storageBucket: "qualy-3b163.firebasestorage.app",
        messagingSenderId: "1057123335204",
        appId: "1:1057123335204:web:f6398fa240b5189a806cb1",
        measurementId: "G-GKYN1439RQ"
    }
}
export default firebaseConfig;